import React from "react";
import { Link } from "react-router-dom";
import "./TermsAndConditions.css";
import { WinnersHeaderBlue } from "../View/WinnersHome/WinnerBlueLan/WinnersHeaderBlue";

const TermsAndConditions = () => {
  return (
    <main className="ws-terms-page">
      <WinnersHeaderBlue />

      {/* =====================================================
          HERO
      ====================================================== */}
      <section className="ws-terms-hero">
        <div className="ws-terms-container">

          <span className="ws-terms-eyebrow">
            WINNERS
          </span>

          <h1>Terms & Conditions</h1>

          <p>
            Please read these Terms & Conditions carefully before
            accessing or using the Winners.in website and services.
          </p>

          <span className="ws-terms-date">
            Last Updated: August 13, 2026
          </span>

        </div>
      </section>


      {/* =====================================================
          CONTENT
      ====================================================== */}
      <section className="ws-terms-content">

        <div className="ws-terms-document">


          {/* =================================================
              01
          ================================================== */}
          <section>
            <span className="ws-terms-number">01</span>

            <h2>Acceptance of Terms</h2>

            <p>
              Welcome to Winners.in . These Terms & Conditions
              govern your access to and use of our website,
              property listings, enquiry services and related
              features.
            </p>

            <p>
              By accessing, browsing or using our website, you
              acknowledge that you have read, understood and agreed
              to these Terms & Conditions.
            </p>

            <p>
              If you do not agree with these terms, please do not
              use our website or services.
            </p>
          </section>


          {/* =================================================
              02
          ================================================== */}
          <section>
            <span className="ws-terms-number">02</span>

            <h2>About Winners </h2>

            <p>
              Winners.in is a real-estate platform that provides
              users with information about properties, projects,
              real-estate opportunities and related services.
            </p>

            <p>
              Depending on the service, Winners may facilitate
              communication between users and property owners,
              developers, agents, brokers or other relevant parties.
            </p>

            <div className="ws-terms-highlight">
              <strong>Important</strong>

              <p>
                Winners is not necessarily the owner, developer,
                builder or seller of every property displayed on the
                website unless expressly stated otherwise.
              </p>
            </div>
          </section>


          {/* =================================================
              03
          ================================================== */}
          <section>
            <span className="ws-terms-number">03</span>

            <h2>Eligibility</h2>

            <p>
              By using our website, you confirm that you are legally
              capable of entering into a binding agreement under
              applicable law.
            </p>

            <ul>
              <li>
                You must provide accurate information when requested.
              </li>

              <li>
                You must use the website only for lawful purposes.
              </li>

              <li>
                You must not use another person's identity or
                information without authorisation.
              </li>

              <li>
                You must comply with applicable laws and regulations.
              </li>
            </ul>
          </section>


          {/* =================================================
              04
          ================================================== */}
          <section>
            <span className="ws-terms-number">04</span>

            <h2>Property Listings & Information</h2>

            <p>
              We make reasonable efforts to provide useful and
              up-to-date property information. However, property
              information may be provided by property owners,
              developers, agents or other third parties.
            </p>

            <p>
              Property information may include:
            </p>

            <ul>
              <li>Property prices.</li>
              <li>Availability.</li>
              <li>Property specifications.</li>
              <li>Floor plans.</li>
              <li>Photographs and videos.</li>
              <li>Amenities and facilities.</li>
              <li>Location information.</li>
              <li>Project completion information.</li>
              <li>Developer or seller information.</li>
            </ul>

            <p>
              Such information may change without prior notice.
              Users should independently verify important information
              before relying on it.
            </p>
          </section>


          {/* =================================================
              05
          ================================================== */}
          <section>
            <span className="ws-terms-number">05</span>

            <h2>Property Due Diligence</h2>

            <p>
              Real-estate transactions involve significant financial
              and legal considerations. Users are responsible for
              conducting appropriate due diligence before purchasing,
              booking, renting or investing in a property.
            </p>

            <p>Users should independently verify, where applicable:</p>

            <ul>
              <li>Ownership and title documents.</li>

              <li>RERA registration and related information.</li>

              <li>Government approvals and permissions.</li>

              <li>Building and development permissions.</li>

              <li>Property taxes and outstanding dues.</li>

              <li>Loan or mortgage obligations.</li>

              <li>Pricing, charges and applicable taxes.</li>

              <li>Developer or seller credentials.</li>

              <li>Agreement and transaction documentation.</li>
            </ul>

            <div className="ws-terms-highlight">
              <strong>Investment Disclaimer</strong>

              <p>
                Information available on Winners.in should not
                be treated as legal, financial, tax or investment
                advice. Please consult qualified professionals where
                appropriate.
              </p>
            </div>
          </section>


          {/* =================================================
              06
          ================================================== */}
          <section>
            <span className="ws-terms-number">06</span>

            <h2>User Enquiries & Communication</h2>

            <p>
              When you submit an enquiry through our website, you
              agree that Winners.in and relevant property
              partners may contact you regarding your enquiry.
            </p>

            <p>
              Depending on the enquiry, communication may take place
              through:
            </p>

            <ul>
              <li>Phone calls.</li>
              <li>Email.</li>
              <li>SMS.</li>
              <li>WhatsApp.</li>
              <li>Other permitted communication channels.</li>
            </ul>

            <p>
              You should provide accurate contact information so that
              we can respond to your request.
            </p>
          </section>


          {/* =================================================
              07
          ================================================== */}
          <section>
            <span className="ws-terms-number">07</span>

            <h2>User Conduct</h2>

            <p>
              You agree to use the website responsibly and lawfully.
            </p>

            <p>You must not:</p>

            <ul>
              <li>
                Use the website for unlawful or fraudulent purposes.
              </li>

              <li>
                Submit false, misleading or inaccurate information.
              </li>

              <li>
                Impersonate another person or organisation.
              </li>

              <li>
                Attempt to gain unauthorised access to our systems.
              </li>

              <li>
                Upload viruses, malicious code or harmful software.
              </li>

              <li>
                Interfere with the operation or security of the website.
              </li>

              <li>
                Scrape, copy or systematically extract website data
                without written permission.
              </li>

              <li>
                Use property information for unlawful or fraudulent
                purposes.
              </li>

              <li>
                Infringe the intellectual property or privacy rights
                of another person.
              </li>
            </ul>
          </section>


          {/* =================================================
              08
          ================================================== */}
          <section>
            <span className="ws-terms-number">08</span>

            <h2>User Submitted Content</h2>

            <p>
              If our website allows users to submit reviews,
              photographs, property information, comments or other
              content, you are responsible for the content you submit.
            </p>

            <p>
              By submitting content, you confirm that:
            </p>

            <ul>
              <li>
                You have the right to submit the content.
              </li>

              <li>
                The content does not infringe another person's rights.
              </li>

              <li>
                The content is not fraudulent or misleading.
              </li>

              <li>
                The content does not contain unlawful or harmful
                material.
              </li>
            </ul>

            <p>
              Winners reserves the right to remove content
              that violates these Terms & Conditions or applicable law.
            </p>
          </section>


          {/* =================================================
              09
          ================================================== */}
          <section>
            <span className="ws-terms-number">09</span>

            <h2>Intellectual Property</h2>

            <p>
              Unless otherwise stated, the content and materials
              available on the Winners.in website are owned by,
              licensed to or used with permission by Winners.
            </p>

            <p>This may include:</p>

            <ul>
              <li>Winners branding and logos.</li>
              <li>Website design and layouts.</li>
              <li>Text and written content.</li>
              <li>Graphics and illustrations.</li>
              <li>Photographs and videos.</li>
              <li>Software and website functionality.</li>
            </ul>

            <p>
              You may not reproduce, modify, distribute, sell,
              republish or commercially exploit such content without
              appropriate written permission.
            </p>
          </section>


          {/* =================================================
              10
          ================================================== */}
          <section>
            <span className="ws-terms-number">10</span>

            <h2>Third-Party Websites & Services</h2>

            <p>
              Our website may contain links to third-party websites,
              property developers, service providers or other external
              platforms.
            </p>

            <p>
              These websites operate independently from Winners.
              We are not responsible for their content, availability,
              security, privacy practices or terms.
            </p>

            <p>
              You should review the applicable terms and privacy
              policies before using any third-party website.
            </p>
          </section>


          {/* =================================================
              11
          ================================================== */}
          <section>
            <span className="ws-terms-number">11</span>

            <h2>Website Availability</h2>

            <p>
              We aim to keep our website available and functioning
              properly. However, we do not guarantee uninterrupted
              access.
            </p>

            <p>
              The website may occasionally become unavailable due to:
            </p>

            <ul>
              <li>Maintenance.</li>
              <li>Technical issues.</li>
              <li>Server problems.</li>
              <li>Network interruptions.</li>
              <li>Security incidents.</li>
              <li>Events outside our reasonable control.</li>
            </ul>
          </section>


          {/* =================================================
              12
          ================================================== */}
          <section>
            <span className="ws-terms-number">12</span>

            <h2>Disclaimer of Warranties</h2>

            <p>
              The website and its content are provided for general
              informational purposes and, to the extent permitted
              by applicable law, are provided on an "as available"
              basis.
            </p>

            <p>
              We do not guarantee that:
            </p>

            <ul>
              <li>
                All property information will always be complete.
              </li>

              <li>
                All information will always be current.
              </li>

              <li>
                Property listings will always remain available.
              </li>

              <li>
                The website will always be free from technical errors.
              </li>

              <li>
                Third-party information will always be accurate.
              </li>
            </ul>

            <div className="ws-terms-highlight">
              <strong>Please Verify Before You Transact</strong>

              <p>
                Users should verify material property information
                directly with the relevant owner, developer, agent,
                authority or other appropriate source before entering
                into a transaction.
              </p>
            </div>
          </section>


          {/* =================================================
              13
          ================================================== */}
          <section>
            <span className="ws-terms-number">13</span>

            <h2>Limitation of Liability</h2>

            <p>
              To the maximum extent permitted by applicable law,
              Winners shall not be responsible for losses
              arising from:
            </p>

            <ul>
              <li>
                Reliance on inaccurate or outdated third-party
                property information.
              </li>

              <li>
                Changes in property prices or availability.
              </li>

              <li>
                Actions or omissions of property owners, developers,
                agents or other third parties.
              </li>

              <li>
                Temporary website interruptions.
              </li>

              <li>
                Unauthorised access resulting from circumstances
                beyond our reasonable control.
              </li>

              <li>
                Transactions entered into independently by users
                with third parties.
              </li>
            </ul>

            <p>
              Nothing in these Terms & Conditions is intended to
              exclude or limit liability that cannot lawfully be
              excluded or limited under applicable law.
            </p>
          </section>


          {/* =================================================
              14
          ================================================== */}
          <section>
            <span className="ws-terms-number">14</span>

            <h2>Indemnification</h2>

            <p>
              To the extent permitted by applicable law, you agree
              to be responsible for losses, claims or reasonable
              costs arising from your unlawful use of the website,
              violation of these Terms & Conditions or infringement
              of another person's rights.
            </p>
          </section>


          {/* =================================================
              15
          ================================================== */}
          <section>
            <span className="ws-terms-number">15</span>

            <h2>Privacy</h2>

            <p>
              Your use of Winners is also subject to our
              Privacy Policy, which explains how we collect, use
              and protect personal information.
            </p>

            <Link
              to="/privacy-policy"
              className="ws-terms-policy-link"
            >
              Read Privacy Policy
            </Link>
          </section>


          {/* =================================================
              16
          ================================================== */}
          <section>
            <span className="ws-terms-number">16</span>

            <h2>Changes to These Terms</h2>

            <p>
              Winners.in may update these Terms & Conditions
              from time to time to reflect changes in our services,
              website functionality, business practices or applicable
              laws.
            </p>

            <p>
              The updated version will be published on this page
              with a revised "Last Updated" date.
            </p>

            <p>
              Continued use of the website after an update means
              that you acknowledge the revised terms, subject to
              applicable law.
            </p>
          </section>


          {/* =================================================
              17
          ================================================== */}
          <section>
            <span className="ws-terms-number">17</span>

            <h2>Governing Law & Jurisdiction</h2>

            <p>
              These Terms & Conditions shall be governed by and
              interpreted in accordance with the applicable laws
              of India.
            </p>

            <p>
              Subject to applicable law, disputes arising in
              connection with these Terms & Conditions or your use
              of the website shall be subject to the jurisdiction
              of the appropriate courts.
            </p>
          </section>


          {/* =================================================
              18
          ================================================== */}
          <section>
            <span className="ws-terms-number">18</span>

            <h2>Contact Us</h2>

            <p>
              If you have questions about these Terms & Conditions,
              our services or any property-related enquiry, please
              contact us.
            </p>

            <div className="ws-terms-contact">

              <div className="ws-terms-contact-item">
                <span>Email</span>

                <a href="mailto:thewinners2ncr@gmail.com">
                  thewinners2ncr@gmail.com
                </a>
              </div>

              <div className="ws-terms-contact-item">
                <span>Phone</span>

                <a href="tel:+918009903561">
                  +91-8009903561
                </a>
              </div>

              <div className="ws-terms-contact-item">
                <span>Address</span>

                <p>
                  G-9 Garden,
                  <br />
                  East Delhi, India
                </p>
              </div>

            </div>
          </section>


          {/* =================================================
              BOTTOM CTA
          ================================================== */}
          <div className="ws-terms-bottom">

            <div>
              <span>Winners</span>

              <h3>
                Transparency starts with clear terms.
              </h3>

              <p>
                Have a question about our terms or services?
              </p>
               {/* <p>
                Contact our team via Email or Call and we'll be happy to assist you.
              </p> */}
            </div>

            {/* <Link to="/contact-us">
              Contact Us
            </Link> */}
            <a href="#contact-us-section">
              Contact Us
            </a>

          </div>

        </div>
      </section>

    </main>
  );
};

export default TermsAndConditions;